module.exports = __webpack_public_path__ + "media/components/images/panels/5-a-29a388c539f46850d1fa7baf72ec1ae0.jpeg";